import Ajax from "base/Ajax";
import $ from "jquery";
import FieldEditor from "editor/FieldEditor";
import Toolbar from "toolbar/Toolbar";
import ToolbarItemBasic from "toolbar/ToolbarItemBasic";
import ToolbarItemRevisions from "toolbar/ToolbarItemRevisions";
import Message from "base/Message";
import ConfirmModal from "modal/ConfirmModal";
import RevisionSidebar from "sidebar/RevisionSidebar";
import PageSettingsModal from "page/PageSettingsModal";
import PublishModal from "page/PublishModal";
import EventEmitter from "base/EventEmitter";
import GlobalEvents from "base/GlobalEvents";
import ProxiedEventEmitter from "base/ProxiedEventEmitter";
import ValueHelper from "base/ValueHelper";

class Page extends EventEmitter {
    constructor(name) {
        super();

        this.pipe(new ProxiedEventEmitter((data) => data.name = "page." + data.name)).pipe(GlobalEvents);

        this.name = name;
        this.revisionsSidebar = null;
        this.draftsSidebar = null;
        this.revisions = [];
        this.drafts = [];
        this.workingRevision = null;
        this.workingRevisionOrig = null;
        this.currentRevision = null;
        this.loadPromise = null;
        this.editing = false;
        this.editors = {};
        this.toolbarItems = {};

        this.loadCurrentRevision();
        this.bindEvents();
    }

    bindEvents() {
        Toolbar.addDefaultItem(new ToolbarItemBasic('Edit Page', () => this.beginEditing(), 'pencil'));

        this.toolbarItems = {
            revisions: new ToolbarItemRevisions(() => {
                this.revisionsSidebar.toggle();
                this.draftsSidebar.close();
            }, "History"),
            drafts: new ToolbarItemRevisions(() => {
                this.draftsSidebar.toggle();
                this.revisionsSidebar.close();
            }, "Drafts & Scheduled"),
            settings: new ToolbarItemBasic("Page Settings", () => this.showSettings(), 'cog'),
            cancel: new ToolbarItemBasic("Cancel", () => this.cancel(), 'cancel'),
        };

        const me = this;
        this.$controls = $("<div>").addClass("bottom-controls")
            .append($("<button>").addClass("js-save admin-btn admin-btn--confirm").text("Save & Publish").on("click", function () {
                let modal = new PublishModal(me.workingRevision);

                modal.on("save", (callback) => {
                    me.save().then(() => {
                        callback();
                        modal.destroy();
                    }).catch(() => {
                        callback();
                    })
                });

                modal.show();
                return false;
            }))
            .append($("<button>").addClass("js-save-draft admin-btn admin-btn--draft").text("Save Draft").on("click", function () {
                if ($(this).is(".admin-btn--loading")) return false;
                $(this).addClass("admin-btn--loading");
                me.workingRevision.status = "2" /* Draft */;
                me.save().then(() => $(this).removeClass("admin-btn--loading")).catch(() => $(this).removeClass("admin-btn--loading"));
                return false;
            }))
            .append($("<button>").addClass("js-cancel admin-btn admin-btn--cancel").text("Cancel").on("click", () => {
                me.cancel();
                return false;
            })).hide();

        $("body").append(this.$controls);
        this.revisionsSidebar = new RevisionSidebar((page) => this.loadRevisions(page), (revisionId) => {
            $.each(this.revisions, (_, revision) => {
                if (revision.id === revisionId) {
                    this.setRevision(revision);
                    return false;
                }
            });
            this.draftsSidebar.updateList();
        }).on("open close", () => {
            this.toolbarItems.revisions.active = this.revisionsSidebar.isOpen;
            Toolbar.update();
        });
        this.draftsSidebar = new RevisionSidebar((page) => this.loadDrafts(page), (revisionId) => {
            $.each(this.drafts, (_, revision) => {
                if (revision.id === revisionId) {
                    this.setRevision(revision);
                    return false;
                }
            });
            this.revisionsSidebar.updateList();
        }).on("open close", () => {
            this.toolbarItems.drafts.active = this.draftsSidebar.isOpen;
            Toolbar.update();
        });

        window.onbeforeunload = () => {
            if (this.editing && this.hasPageChanged()) {
                return !confirm("You have made changes to this page. All unsaved changes will be lost. Are you sure?")
            }
        }
    }


    loadRevisions(page) {
        return Ajax.get("pages", this.name + "/revisions", {page: page}).then((revisions) => {
            revisions.forEach((revision) => {
                revision.active = false;
                revision.current = this.currentRevision.id === revision.id;
                revision.statusText = revision.status.id !== "1" /* Active */ ? revision.status.name : null;
                revision.date = revision.publishedDate ? revision.publishedDate : revision.dateUpdated;
            });
            this.revisions = this.revisions.concat(revisions);
            return revisions;
        })
    }


    loadCurrentRevision() {
        this.loadPromise = Ajax.get("pages", this.name + "/revisions/active");
        this.loadPromise.then((revision) => {
            if ($.isArray(revision.values)) revision.values = {};
            this.currentRevision = $.extend(true, {}, revision);
            this.workingRevision = $.extend(true, {}, revision);
            this.workingRevisionOrig = $.extend(true, {}, revision);
            this.workingRevision.status = this.workingRevision.status.id;
            delete this.workingRevision.user;
            delete this.workingRevision.dateUpdated;
            delete this.workingRevision.date;
        }).catch(function (e) {
            console.log(e);
            new Message(e.message, "Couldn't load page data", Message.ERROR);
        });
    }

    beginEditing() {
        if (this.editing) return;
        if (!this.emit("beginEditing")) return;
        this.editing = true;
        $("body").addClass("editing-page");

        this.$controls.show();
        Toolbar.setItems([this.toolbarItems['cancel'], this.toolbarItems['settings']]);
        Toolbar.setItems([this.toolbarItems['drafts'], this.toolbarItems['revisions']], Toolbar.RIGHT);

        this.loadPromise.then(() => {
            const me = this;
            $(".js-editable").each(function () {
                let name = $(this).attr("data-field");
                let editorType = $(this).is("[data-editor]") ? $(this).attr("data-editor") : "wysiwyg";
                let settings = $(this).is("[data-settings]") ? JSON.parse($(this).attr("data-settings")) : {};
                if ("undefined" === typeof me.editors[name]) {
                    me.editors[name] = FieldEditor.get_editor(editorType, $(this), settings);
                } else {
                    console.error("Duplicate editors!", name);
                }

            });
            this.emit("editingBegan", this)
        });
    }

    save() {
        this.updateWorkingRevision();
        if (!this.emit("save")) return;

        let prom;
        if (this.workingRevisionOrig.status.id !== "1") {
            //Update current revisions
            prom = Ajax.put(null, this.workingRevision.href, this.workingRevision, Ajax.ADMIN)
        } else {
            //Add new revision
            prom = Ajax.post('pages', this.name + '/revisions', this.workingRevision, Ajax.ADMIN)
        }
        return prom.then((revision) => {
            if (revision.status.id === "1") {
                this.currentRevision = $.extend(true, {}, revision);
            }
            this.setRevision(this.currentRevision);
            this.emit("saved");
            this.stopEditing();
            this.revisionsSidebar.reload();
            this.draftsSidebar.reload();
            new Message('', this.workingRevision.status === "2" ? 'Your draft has been saved' : 'Your changes to the page have been ' + (this.workingRevision.status === "1" ? "saved" : "scheduled"), Message.SUCCESS);
        }, (e) => new Message(e.message, "Couldn't save your changes"))
    }

    /**
     * Stops editing while preserving the current state of the editors
     */
    stopEditing() {
        if (!this.editing) return;
        if (!this.emit("stopEditing")) return;
        this.editing = false;
        $("body").removeClass("editing-page");

        $.each(this.editors, (_, editor) => {
            try {
                editor.destroy();
            } catch (e) {
                console.error("Couldn't destroy editor", e);
            }
        });
        this.editors = {};
        this.$controls.hide();
        this.revisionsSidebar.close();
        this.draftsSidebar.close();
        Toolbar.reset();
    }

    hasPageChanged() {
        this.updateWorkingRevision();

        return ValueHelper.obj_compare(this.workingRevision, this.currentRevision) === false;
    }

    cancel() {
        if (!this.editing) return;
        let message = '';
        let metaFields = ['meta title', 'meta description'];
        let metaChanged = false, contentChanged = false;

        this.updateWorkingRevision();
        $.each(this.workingRevision.values, (key, value) => {
            let changed = value !== this.currentRevision.values[key];
            if (metaFields.indexOf(key) !== -1) {
                metaChanged |= changed;
            } else {
                contentChanged |= changed;
            }
        });

        if (metaChanged && contentChanged) {
            message = 'You have unsaved changes to the page content and meta settings, these will be lost';
        } else if (metaChanged) {
            message = 'You have unsaved changes to the page meta settings, these will be lost';
        } else if (contentChanged) {
            message = 'You have unsaved changes to the page content, these will be lost';
        }

        let prom;

        if (message.length === 0) {
            prom = Promise.resolve();
        } else {
            prom = ConfirmModal.confirm(message);
        }

        prom.then(() => {
            this.setRevision(this.currentRevision);
            this.stopEditing();
        }, console.error.bind(console));
    }

    updateWorkingRevision() {
        $.each(this.editors, (key, editor) => {
            this.workingRevision.values[key] = editor.getValue();
        })
    }

    showSettings(tab = null) {
        let modal = new PageSettingsModal(this, tab);
        this.emit("pageSettings", {modal: modal});
        modal.show();
    }

    setRevision(revision) {
        if (!this.emit("setRevision", {revision: revision})) return;

        $.each(this.revisions, (_, revision) => {
            revision.active = false;
            revision.current = revision.id === this.currentRevision.id;
        });
        $.each(this.drafts, (_, revision) => {
            revision.active = false;
            revision.current = revision.id === this.currentRevision.id;
        });

        revision.active = true;
        this.workingRevision = $.extend(true, {}, revision);
        this.workingRevisionOrig = $.extend(true, {}, revision);
        this.workingRevision.status = this.workingRevision.status.id;
        delete this.workingRevision.user;
        delete this.workingRevision.dateUpdated;
        delete this.workingRevision.date;
        $.each(revision.values, (key, value) => {
            this.updateValue(key, value);
        })
    }

    updateValue(name, value) {
        if (this.editors[name] instanceof FieldEditor) {
            this.editors[name].setValue(value);
        } else {
            console.info("Missing field editor %s", name);
        }
        this.workingRevision.values[name] = value;
    }

    loadDrafts(page) {
        return Ajax.get("pages", this.name + "/drafts", {page: page}).then((revisions) => {
            revisions.forEach((revision) => {
                revision.active = false;
                revision.current = this.currentRevision.id === revision.id;
                revision.statusText = revision.status.id !== "1" /* Active */ ? revision.status.name : null;
                revision.date = revision.publishedDate ? revision.publishedDate : revision.dateUpdated;
            });
            this.drafts = this.drafts.concat(revisions);
            return revisions;
        })
    }
}

export default Page;
